import { Component, ElementRef, HostListener, inject, signal } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { ThemeService } from '../../../core/services/theme.service';
import { AuthService } from '../../../auth/services/auth.service';
import { NotificationService } from '../../../core/services/notification.service';
import { LanguageService } from '../../../core/services/language.service';
import { ROUTES } from '../../../core/constants/routes.constants';
import { NavLink } from '../../interfaces/layout.type';

@Component({
  selector: 'app-header',
  imports: [RouterLink, RouterLinkActive, TranslatePipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  private readonly router = inject(Router);
  private readonly elRef = inject(ElementRef);
  protected readonly authService = inject(AuthService);
  protected readonly themeService = inject(ThemeService);
  protected readonly notificationService = inject(NotificationService);
  protected readonly languageService = inject(LanguageService);
  protected readonly routes = ROUTES;

  protected readonly navLinks: NavLink[] = [
    { label: 'nav.home', path: ROUTES.HOME },
    { label: 'nav.quran', path: ROUTES.QURAN },
    { label: 'nav.duas_azkar', path: ROUTES.DUAS_AZKAR },
    { label: 'nav.amaal_planner', path: ROUTES.AMAAL_PLANNER },
    { label: 'nav.qibla_finder', path: ROUTES.QIBLA_FINDER },
    { label: 'nav.history', path: ROUTES.HISTORY }
  ];

  protected readonly moreMenuOpen = signal(false);
  protected readonly mobileMenuOpen = signal(false);
  protected readonly themeMenuOpen = signal(false);
  protected readonly userMenuOpen = signal(false);
  protected readonly notifMenuOpen = signal(false);
  protected readonly langMenuOpen = signal(false);

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.notifMenuOpen.set(false);
      this.themeMenuOpen.set(false);
      this.userMenuOpen.set(false);
      this.moreMenuOpen.set(false);
      this.langMenuOpen.set(false);
    }
  }

  toggleMoreMenu(): void { this.moreMenuOpen.update(o => !o); }
  toggleMobileMenu(): void { this.mobileMenuOpen.update(o => !o); }
  closeMobileMenu(): void { this.mobileMenuOpen.set(false); }
  closeMoreMenu(): void { this.moreMenuOpen.set(false); this.mobileMenuOpen.set(false); }
  toggleThemeMenu(): void { this.themeMenuOpen.update(o => !o); this.langMenuOpen.set(false); }
  toggleNotifMenu(): void { this.notifMenuOpen.update(o => !o); this.userMenuOpen.set(false); this.themeMenuOpen.set(false); }
  toggleUserMenu(): void { this.userMenuOpen.update(o => !o); this.notifMenuOpen.set(false); }
  toggleLangMenu(): void { this.langMenuOpen.update(o => !o); this.themeMenuOpen.set(false); this.notifMenuOpen.set(false); this.userMenuOpen.set(false); }

  selectTheme(id: string): void {
    this.themeService.setTheme(id);
    this.themeMenuOpen.set(false);
  }

  selectLanguage(code: string): void {
    this.languageService.setLanguage(code);
    this.langMenuOpen.set(false);
  }

  currentThemeOption() {
    return this.themeService.themes.find(t => t.id === this.themeService.currentTheme());
  }

  logout(): void {
    this.userMenuOpen.set(false);
    this.authService.logout().subscribe(() => this.router.navigateByUrl(ROUTES.HOME));
  }
}
